/*
* Dinamic fee because the price changes globally
* Transfer amount does not affect it
*/
export default [
  'eth',
  'bnb',
  'matic',
  'arbeth',
  'aureth',
  'phi',
  'xdai',
  'ftm',
  'avax',
  'movr',
  'one',
  'btc',
  'ghost',
  'next',
]